import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit/responsive';

import { Navigation } from '../../components/Navigation';
import { NotDesktop } from '../../../packages/Responsive';
import { FiltersButtonContainer } from './FiltersButton';
import { SaveSearchButtonContainer } from './SaveSearchButton';
import { ListingButtonContainer } from './ListingButton';

export const NavigationContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const navigationIndentType = deviceType === 'desktop' ? 'L' : 'M';

  return (
    <Navigation indent={navigationIndentType}>
      <NotDesktop>
        <FiltersButtonContainer />
        <SaveSearchButtonContainer />
      </NotDesktop>
      <ListingButtonContainer />
    </Navigation>
  );
};

NavigationContainer.displayName = 'NavigationContainer';
